/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { BindActivityInfo, Detail } from "@/components/top-up/types";
import { useEffect } from "react";
import { useFoxTopUpStore } from "../../store";
import {
  RadioContent,
  RechargeRadio,
  RechargeRadioCircle,
  RechargeRadioList,
  RechargeRadioWrapper,
} from "./atom";
import {
  findWelfareData,
  presentAmountCalculate,
} from "@/components/top-up/help/activityUtil";
import { couponTypeTranslate } from "@/components/top-up/help/couponTypeTranslate";
import { useTranslation } from "react-i18next";
import { CommonTitle } from "../../atom";

export function ActivityRechargeRadioList({
  activityInfo,
}: {
  activityInfo: BindActivityInfo;
}) {
  const { t } = useTranslation("topup");
  const { currencySymbol } = useGlobalStore();
  const amount = useFoxTopUpStore((state) => state.amount);
  const checkedRadioId = useFoxTopUpStore((state) => state.checkedRadioId);
  const setFoxTopUpStore = useFoxTopUpStore((state) => state.setter);

  const welfareData = findWelfareData(activityInfo, Number(amount));

  useEffect(() => {
    setFoxTopUpStore({
      checkedRadioId: 0,
    });
  }, [amount]);

  return (
    <RechargeRadioWrapper>
      <CommonTitle>{t("topup_extra_benefits")}</CommonTitle>
      <RechargeRadioList>
        {welfareData &&
          welfareData.detailList?.map((item: Detail) => {
            return (
              <RechargeRadio
                key={item.id}
                className={item.id === checkedRadioId ? "active" : ""}
                onClick={() => {
                  setFoxTopUpStore({
                    checkedRadioId: item.id,
                  });
                }}
              >
                <RechargeRadioCircle />
                <RadioContent>
                  <span>{currencySymbol}</span>
                  <span className={"price"}>
                    {presentAmountCalculate(
                      activityInfo,
                      Number(amount),
                      item.presentAmount
                    )}
                  </span>
                  <span>{couponTypeTranslate(item.couponType)}</span>
                </RadioContent>
              </RechargeRadio>
            );
          })}
      </RechargeRadioList>
    </RechargeRadioWrapper>
  );
}
